module.exports = __webpack_public_path__ + "static/media/community-third@3x.944bd364.jpg";